import React, { useState, useEffect } from "react";
import api from "../Services/api";

const Cargo = (props: any) => {

  const [cargos, setCargos] = useState<any[]>([]);

  useEffect(() => {
    api
      .get("/ObterCargos")

      .then((response) => {
        setCargos(response.data.results);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);



  const buttonMessage = (data: string) => {

    let cargo = data.replace(/-.*$/, "");

    // remove spaces  
    cargo = cargo.replace(/\s/g, "");

    switch (cargo) {
      case "Diretor":
        return "Fale com o Diretor";
      case "Presidente":
        return "Fale com o Presidente";
      case "Gerente":
        return "Fale com o Gerente";
      case "Coordenador":
        return "Fale com o Coordenador";
      case "Supervisor":
        return "Fale com o Supervisor";
      case "Diretora":
        return "Fale com a Diretora";

      default:
        break;

    }
  }

  function locationId(data: string) {
    window.location.href = `../Contato/fale-conosco#${data}`;
  }

  let hrefLink = '#';

  return (

    <section className="_the-content page-diretoria pb-10">
      <div className='container'>

        <>
          {cargos?.filter(i => i.Area === props.page).map(item => (

            <div className="row justify-content-center mb-10 pb-8">
              <div className="col-lg-4 order-2 order-lg-1 mt-3 mt-lg-0">
                <div className="page-diretoria__card-img text-center">
                  {item?.Imagem ?
                    <img src={item?.Imagem} alt="Descrição" /> : ''
                  }
                  <a href={hrefLink} className="py-3 px-5 btn btn-primary rounded d-block d-lg-none btn-100 mt-6"> Fale com o {item?.Title} </a>

                </div>
              </div>

              <div className="col-lg-6 order-1 order-lg-2">
                <div className="page-diretoria__card-text">
                  <p className="presidente"> {item?.Title.toUpperCase()} </p>
                  <h2 className="h3"> {item?.Nome} </h2>
                  <span> <strong> Mandato: </strong> {item?.Mandato_x0020_Inicio} a {item?.Mandato_x0020_Fim}  </span>

                  <p className="mt-6">
                    {item?.Descricao}
                  </p>
                  <a href={hrefLink} onClick={() => locationId(item?.Origem)} className="py-3 px-5 btn btn-primary rounded d-none d-lg-inline-block mt-4"> {buttonMessage(item?.Title)} </a>
                </div>
              </div>
            </div>
          ))}
        </>


      </div>
    </section>

  )
};
export default Cargo;